import { type RequestListFolderFragmentFragment } from '@app-types/blackroom-api';
import { type FlatRequestListFolder } from '../RequestListTable/utils/transformToNestedData';

export function normalizeSearchValue(value?: string | null) {
  return (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

function folderMatchesSearch(
  item: RequestListFolderFragmentFragment,
  normalizedQuery: string,
) {
  const searchableValue = normalizeSearchValue(
    [item.index, item.name, item.requestMetadata?.description].join(' '),
  );

  return searchableValue.includes(normalizedQuery);
}

function addItemAndAncestors(
  item: RequestListFolderFragmentFragment,
  itemById: Map<string, RequestListFolderFragmentFragment>,
  visibleIds: Set<string>,
) {
  const visited = new Set<string>();
  let currentItem: RequestListFolderFragmentFragment | undefined = item;

  while (currentItem && !visited.has(currentItem.id)) {
    visibleIds.add(currentItem.id);
    visited.add(currentItem.id);
    currentItem = currentItem.parentId
      ? itemById.get(currentItem.parentId)
      : undefined;
  }
}

export function filterRowsBySearch(
  rows: FlatRequestListFolder[],
  normalizedQuery: string,
) {
  if (!normalizedQuery) return rows;

  const visibleIds = new Set<string>();
  const itemById = new Map(rows.map(({ item }) => [item.id, item]));

  rows.forEach(({ item }) => {
    if (!folderMatchesSearch(item, normalizedQuery)) return;
    addItemAndAncestors(item, itemById, visibleIds);
  });

  return rows.filter(({ item }) => visibleIds.has(item.id));
}
